import React, { FC } from 'react';
import classNames from 'classnames';
import { Hyperlink } from '../../../../../components/Hyperlink';
import styles from './legislation_level_components.module.scss';
import { getDateKey } from '../../../../../utils/date-utils/dateUtils';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';

export const LegislationLevelContentTitle: FC<{
  sectionId: string;
  level: number;
  title: string;
  textId: string;
  source: string;
  dateKey: Date | string;
  url: string;
}> = ({ level, title, children, source, dateKey, url }) => {
  const today = getDateKey(new Date());
  return (
    <div className={styles[`rowLevel${level}`]}>
      <Hyperlink
        href={buildUrlWithParameters(url, {
          source,
          ...(dateKey && today !== dateKey && { dateKey }),
        })}
      >
        {level === 1 && (
          <h2 className={classNames(styles.mainContentTitleH2, styles.link)}>
            {title}
          </h2>
        )}
        {level === 2 && (
          <h3 className={classNames(styles.mainContentTitleH3, styles.link)}>
            {title}
          </h3>
        )}
        {level === 3 && (
          <div className={classNames(styles.mainContentTitleH4, styles.link)}>
            {title}
          </div>
        )}
        {level === 4 && (
          <div className={classNames(styles.mainContentTitleH5, styles.link)}>
            {title}
          </div>
        )}
        {level > 4 && (
          <div className={classNames(styles.otherContentTitle, styles.link)}>
            {title}
          </div>
        )}
      </Hyperlink>
      {children}
    </div>
  );
};
